import { AlertCircle, X } from 'lucide-react';

function Notice({ notice, onClose }) {
    if (!notice) return null;

    return (
        <div className="bg-gradient-to-r from-red-500/[0.08] to-red-500/[0.02] border border-red-500/40 rounded-xl mb-4 px-4 py-3.5 flex gap-3 items-start animate-in slide-in-from-top-2 fade-in duration-300">
            <div className="flex-shrink-0 w-6 h-6 rounded-lg bg-red-500/20 flex items-center justify-center text-red-400">
                <AlertCircle className="w-4 h-4" />
            </div>
            <div className="flex-1 min-w-0">
                {notice.title && (
                    <div className="text-red-400 font-bold text-xs uppercase tracking-widest mb-0.5">
                        {notice.title}
                    </div>
                )}
                <div className="text-red-200/90 text-sm leading-relaxed">
                    {notice.message}
                </div>
            </div>
            <button
                onClick={onClose}
                aria-label="Dismiss"
                className="flex-shrink-0 -mr-1 -mt-1 text-zinc-500 hover:text-zinc-300 transition-colors p-1"
            >
                <X className="w-4 h-4" />
            </button>
        </div>
    );
}

export default Notice;
